import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, finalize, forkJoin, from, NEVER, of, switchMap, tap } from 'rxjs';
import { ActionPlanService } from 'src/app/core/services/action-plan.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { GeneratePdfComponent } from 'src/app/shared/layouts/generate-pdf/generate-pdf.component';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { SubmitConfirmationComponent } from '../submit-confirmation/submit-confirmation.component';
import { CategoryService } from 'src/app/core/services/category.service';

@Component({
  selector: 'app-action-item-detail',
  templateUrl: './action-item-detail.component.html',
  styleUrls: ['./action-item-detail.component.css']
})
export class ActionItemDetailComponent implements OnInit, OnDestroy {
  isArabic: any;
  actionPlan: any;
  planDetails: any;
  actionItemsList: any;
  isView: boolean = false;
  fileToUpload: File | null = null;
  actionItemType: any;
  isPending: boolean = false;
  isRejected: boolean = false;
  isHistorical: boolean = false;
  modalRef!: BsModalRef;
  UPDATE_TYPE: any = {
    COMMENT: "Comment",
    FILE_UPSERT: "FileUpsert",
    FILE_DELETE: "FileDelete",
    SUBMIT: "Submit",
    ENABLE_DISABLE_SUBMIT: "EnableDisableSubmit"
  };
  userDetails: any;
  modalRefConfirm!: BsModalRef;
  notificationSubscription: any;
  pdfMasterData: any;

  @ViewChild('generatepdfref', { static: true }) generatePdfCompRef!: GeneratePdfComponent;

  constructor(private storageService: StorageService, private actionPlanService: ActionPlanService,
    private commonService: CommonService, private assessmentService: AssessmentService,
    private route: Router, private activateRoute: ActivatedRoute, private modalService: BsModalService,
    private categoryService: CategoryService, private cd: ChangeDetectorRef) {
    route.events.subscribe((event: any) => {
      this.isPending = false;
      this.isRejected = false;
      this.isHistorical = false;
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        const currentUrl = event.url;
        this.setFlags(currentUrl);
      }
    })
  }



  ngOnInit(): void {
    this.setFlags(this.route.url);
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.actionPlan = this.storageService.getSessionStorageData('selectedPlan');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');

    this.populateActionItemsData();
  }

  // populateActionItemsData() {
  //   const rqstBody = { actionPlanGuid: this.actionPlan.actionPlanId };
  //   this.actionPlanService.getActionItems(rqstBody).subscribe((res: any) => {
  //     if (res?.data) {
  //       let decryptedData = this.commonService.decryptUsingAES256(res?.data);
  //       let resp = JSON.parse(JSON.stringify(decryptedData));
  //       this.planDetails = resp;
  //       this.actionItemsList = this.planDetails?.actionItems;

  //       const filesRqstBody = {
  //         responseguids: this.actionItemsList.map((item: any) => item.actionItemId),
  //       }
  //       console.log(filesRqstBody)
  //       if (this.isRejected) {
  //         this.actionItemsList = this.actionItemsList.filter((item: any) =>
  //           item.actionItemStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.REJECTED.name)
  //       }

  //       this.actionItemsList = this.actionItemsList?.map((item: any) => {
  //         if (item) {
  //           item.comments = "";
  //           item.disableSubmit = false;
  //           // item.fileName = "test.pdf";
  //           item.isSubmitted = item?.actionItemStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.UNDER_REVIEW.name;
  //           item.showError = false;
  //         }
  //         return item;
  //       })

  //       this.populatepdfMasterData();

  //       this.assessmentService.fetchUploadedFiles(filesRqstBody).subscribe((res: any) => {
  //         if (res?.data) {
  //           let decryptedData = this.commonService.decryptUsingAES256(res?.data);
  //           let resp = JSON.parse(JSON.stringify(decryptedData));
  //           this.actionItemsList = this.actionItemsList.map((actionItem: any) => {
  //             if (actionItem) {
  //               // Get all files matching this actionItemId
  //               const files = resp.filter((item: any) => item.responseguid == actionItem.actionItemId) || [];

  //               // Map the files to expected format, e.g. { name: filename } or just keep filename strings
  //               actionItem.attachedFiles = files.map((f: any) => ({
  //                 name: f.filename,
  //                 isExisting: true,
  //               }));
  //             }
  //             return actionItem;
  //           })
  //         }
  //       })
  //     }
  //   }), (error: any) => {

  //   };
  // }
  populateActionItemsData() {
    const rqstBody = { actionPlanGuid: this.actionPlan.actionPlanId };
    this.actionPlanService.getActionItems(rqstBody).subscribe((res: any) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.planDetails = resp;
        this.actionItemsList = this.planDetails?.actionItems;

        if (this.isRejected) {
          this.actionItemsList = this.actionItemsList.filter((item: any) =>
            item.actionItemStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.REJECTED.name
          );
        }

        this.actionItemsList = this.actionItemsList?.map((item: any) => {
          if (item) {
            item.comments = "";
            item.disableSubmit = false;
            item.isSubmitted = item?.actionItemStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.UNDER_REVIEW.name;
            item.showError = false;
          }
          return item;
        });

        const filesRqstBody = {
          responseguids: this.actionItemsList.map((item: any) => item.actionItemId),
        };
        // console.log('filesRqstBody:', filesRqstBody);

        this.populatepdfMasterData();

        this.assessmentService.fetchUploadedFiles(filesRqstBody).subscribe((res: any) => {
          if (res?.data) {
            let decryptedData = this.commonService.decryptUsingAES256(res?.data);
            let resp = JSON.parse(JSON.stringify(decryptedData));
            this.actionItemsList = this.actionItemsList.map((actionItem: any) => {
              if (actionItem) {
                const files = resp.filter((item: any) => item.responseguid == actionItem.actionItemId) || [];
                actionItem.attachedFiles = files.map((f: any) => ({
                  name: f.filename,
                  isExisting: true,
                }));
              }
              return actionItem;
            });
          }
        });
      }
    }), (error: any) => {
      console.log(error)
    };
  }
  populatepdfMasterData() {
    this.pdfMasterData = this.actionItemsList.map((item: any) => {
      let commentHistoryArr = item?.commentHistory?.split('\n');
      item.commentHistory = commentHistoryArr;
      return item;
    })
  }

  setFlags(currentUrl: any) {
    if (currentUrl.includes('action-items/pending/details')) {
      this.actionItemType = 'pending';
      this.isPending = true;
    }
    else if (currentUrl.includes('action-items/rejected/details')) {
      this.actionItemType = 'rejected';
      this.isRejected = true;
    }
    else if (currentUrl.includes('action-items/historical/details')) {
      this.actionItemType = 'historical';
      this.isHistorical = true;
    }
  }

  handleKeyUpDelegation(event: any) {
    if (event.target.nodeName == "TEXTAREA") {
      const attrList = Array.from(event.target.attributes).map((x: any) => x.name).filter((y: any) => (y == "commentsbox"));
      if (attrList?.length > 0) {
        this.updateActionItem(event.target.id, event.target.value, this.UPDATE_TYPE.ENABLE_DISABLE_SUBMIT);
      }
    }
  }

  // handlePlanButtonsDelegation(event: any) {
  //   if (event.target.nodeName === "BUTTON" || event.target.nodeName === "IMG") {
  //     const attrList = Array.from(event.target.attributes)
  //       .map((x: any) => x.name)
  //       .filter((y: any) => (y === "notesdelete") || (y === "actionitemsubmit"));
  //     if (attrList?.length > 0) {
  //       switch (attrList[0]) {
  //         case 'notesdelete': {
  //           const fileIndexStr = event.target.getAttribute('data-file-index');
  //           const fileIndex = fileIndexStr !== null ? +fileIndexStr : null;
  //           if (fileIndex !== null && !isNaN(fileIndex)) {
  //             console.log("delete")
  //             this.updateActionItem(event.target.id, fileIndex, this.UPDATE_TYPE.FILE_DELETE);
  //           } else {
  //             console.warn('File index missing or invalid in delete event');
  //           }
  //           break;
  //         }
  //         case 'actionitemsubmit':
  //           this.updateActionItem(event.target.id, null, this.UPDATE_TYPE.SUBMIT);
  //           break;
  //         default:
  //           break;
  //       }
  //     }
  //   }
  // }
  // handleChangeDelegation(event: any) {
  //   if (event.target.nodeName == "TEXTAREA" || event.target.nodeName == "INPUT") {
  //     const attrList = Array.from(event.target.attributes).map((x: any) => x.name).filter((y: any) =>
  //       (y == "commentsbox") || (y == "notesupload") || (y == "notesedit"));
  //     if (attrList?.length > 0) {
  //       switch (attrList[0]) {
  //         case 'commentsbox': this.updateActionItem(event.target.id, event.target.value, this.UPDATE_TYPE.COMMENT);
  //           break;
  //         case 'notesupload': this.updateActionItem(event.target.id, event.target.files, this.UPDATE_TYPE.FILE_UPSERT);
  //           break;
  //         case 'notesedit': this.updateActionItem(event.target.id, event.target.files, this.UPDATE_TYPE.FILE_UPSERT);
  //           break;
  //         default: break;
  //       }
  //     }
  //   }
  // }
  // updateActionItem(idStr: any, value: any, type: any) {
  //   console.log('updateActionItem called with:', { idStr, value, type });

  //   let extractedId = idStr?.split("_")?.pop();
  //   console.log('Extracted actionItemId:', extractedId);
  //   if (!extractedId) {
  //     console.warn('No extractedId from idStr:', idStr);
  //     return;
  //   }
  //   console.log('All actionItemIds:', this.actionItemsList?.map((item: any) => item.actionItemId));
  //   console.log(this.actionItemsList)
  //   let actionItems = this.actionItemsList?.filter((item: any) => {
  //     return String(item?.actionItemId) === extractedId || item?.actionItemId === Number(extractedId);
  //   });
  //   console.log('Matching actionItems:', actionItems);

  //   if (actionItems && actionItems.length > 0 && actionItems[0]) {
  //     let actionItem = actionItems[0];
  //     console.log('Processing actionItem:', actionItem);

  //     switch (type) {
  //       case this.UPDATE_TYPE.COMMENT:
  //         console.log('Updating comment with value:', value);
  //         this.updateComment(actionItem, value);
  //         break;

  //       case this.UPDATE_TYPE.FILE_UPSERT:
  //         console.log('Attaching files:', value);
  //         this.attachFiles(actionItem, value);
  //         break;

  //       case this.UPDATE_TYPE.FILE_DELETE:
  //         console.log('Deleting file at index:', value);
  //         this.deleteFile(actionItem, value);
  //         break;

  //       case this.UPDATE_TYPE.SUBMIT:
  //         console.log('Submitting action item');
  //         this.submitActionItemCheck(actionItem);
  //         break;

  //       case this.UPDATE_TYPE.ENABLE_DISABLE_SUBMIT:
  //         console.log('Checking error with value:', value);
  //         this.checkError(actionItem, value);
  //         break;

  //       default:
  //         console.warn('Unknown update type:', type);
  //         break;
  //     }
  //   } else {
  //     console.warn('No matching actionItem found for extractedId:', extractedId);
  //   }
  // }
  // updateActionItem(idStr: any, value: any, type: any) {
  //   let extractedId = idStr?.split("_")?.pop();
  //   let actionItems = extractedId && this.actionItemsList?.filter((item: any) => item?.actionItemId == extractedId);
  //   if (actionItems && actionItems.length > 0 && actionItems[0]) {
  //     let actionItem = actionItems[0];
  //     switch (type) {
  //       case this.UPDATE_TYPE.COMMENT: this.updateComment(actionItem, value);
  //         break;
  //       case this.UPDATE_TYPE.FILE_UPSERT: this.attachFiles(actionItem, value);
  //         break;
  //       case this.UPDATE_TYPE.FILE_DELETE: this.deleteFile(actionItem, value);
  //         break;
  //       case this.UPDATE_TYPE.SUBMIT: this.submitActionItemCheck(actionItem);
  //         break;
  //       case this.UPDATE_TYPE.ENABLE_DISABLE_SUBMIT: this.checkError(actionItem, value);
  //         break;
  //       default: break;
  //     }
  //   }
  // }

  submitActionItemCheck(actionItem: any) {
    this.checkError(actionItem, actionItem?.comments);
    if (!actionItem?.showError) {
      this.openConfirmationComp(actionItem);
    }
  }

  submitActionItemOld(actionItem: any) {
    this.checkError(actionItem, actionItem?.comments);
    if (!actionItem?.showError) {
      let uploadRequired = actionItem?.fileName && actionItem.attachedFile ? true : false;
      let conversationHistory = '';
      let currentDate = new Date();
      let dateString = `${currentDate.getDate()}.${currentDate.getMonth() + 1}.${currentDate.getFullYear()}`
      let userComment = `${this.userDetails?.firstname} ${this.userDetails?.lastname} - ${dateString} : ${actionItem.comments}`;
      if (actionItem?.commentHistory) {
        conversationHistory = actionItem?.commentHistory + "\n" + userComment;
      }
      else {
        conversationHistory = userComment;
      }
      actionItem.disableSubmit = true;

      const actionItemRqstBody = {
        actionItemGuid: actionItem.actionItemId,
        comments: actionItem.comments,
        commentHistory: conversationHistory,
        actualCompletionDate: new Date()
      }
      const attachmentRqstBody = {
        subjectId: actionItem.actionItemId,
        filename: actionItem.fileName,
        responseguid: actionItem.actionItemId,
        documentBody: actionItem.attachedFile,
        notesType: 'actionitem'
      }

      forkJoin({
        saveActionItem: this.actionPlanService.saveActionItem(actionItemRqstBody),
        uploadFile: uploadRequired ? this.callUploadFile(attachmentRqstBody) : of(null)
      }).pipe(
        finalize(() => actionItem.disableSubmit = false)
      )
        .subscribe((joinedResp: any) => {
          let isActionItemSaved = false;
          let isFileUploaded = false;
          if (joinedResp?.saveActionItem?.data) {
            isActionItemSaved = this.commonService.decryptUsingAES256(joinedResp?.saveActionItem?.data)?.isUpdated;
          }
          if (joinedResp?.uploadFile?.data) {
            isFileUploaded = this.commonService.decryptUsingAES256(joinedResp?.uploadFile?.data)?.isUploaded;
          }
          // console.log("update statuses", isActionItemSaved, isFileUploaded);
          if (isActionItemSaved) {
            actionItem.isSubmitted = true;
            actionItem.comments = '';
            actionItem.commentHistory = conversationHistory;
            this.actionPlanService.setActionPlanCountChange(true);
            this.populateActionItemsData();
          }
        })
    }
  }
  submitActionItem(actionItem: any) {
    this.checkError(actionItem, actionItem?.comments);

    if (!actionItem?.showError) {
      const conversationHistory = this._buildConversationHistory(actionItem);
      actionItem.disableSubmit = true;

      const actionItemRqstBody = {
        actionItemGuid: actionItem.actionItemId,
        comments: actionItem.comments,
        commentHistory: conversationHistory,
        actualCompletionDate: new Date()
      };
      const files = (actionItem.attachedFiles || []).filter((file: any) => file instanceof File);
      const totalFiles = files.length;

      this.showUploadPopup();  // Show popup once at start
      this.updateUploadProgress(0);
      let uploadedFiles = 0;

      // Upload each file individually (if any files exist)
      const uploadObservables = (actionItem.attachedFiles || [])
        .filter((file: any) => file instanceof File)  // filter only new files if you distinguish
        .map((file: File) => {
          const attachmentRqstBody = {
            subjectId: actionItem.actionItemId,
            filename: file.name,
            responseguid: actionItem.actionItemId,
            documentBody: file,
            notesType: 'actionitem'
          };
          return this.callUploadFile(attachmentRqstBody).pipe(
            tap(() => {
              // After each file upload completes:
              uploadedFiles++;
              const percentDone = Math.round((uploadedFiles / totalFiles) * 100);
              this.updateUploadProgress(percentDone);
            })
          );
        });
      // If no files to upload, just return an Observable of null for uploadFiles
      if (uploadObservables.length === 0) {
        uploadObservables.push(of(null));
      }

      forkJoin({
        saveActionItem: this.actionPlanService.saveActionItem(actionItemRqstBody),
        uploadFiles: forkJoin(uploadObservables)
      }).pipe(
        finalize(() => {
          actionItem.disableSubmit = false
          this.hideUploadPopup();
          this.updateUploadProgress(0);
        })
      )
        .subscribe((joinedResp: any) => {
          const isActionItemSaved = this.commonService.decryptUsingAES256(joinedResp?.saveActionItem?.data)?.isUpdated ?? false;
          // For files: check if all uploads succeeded:
          const uploadFilesResults = joinedResp?.uploadFiles || [];
          const isFileUploaded = uploadFilesResults.every((resp: any) => {
            return this.commonService.decryptUsingAES256(resp?.data)?.isUploaded ?? false;
          });

          // console.log("update statuses", isActionItemSaved, isFileUploaded);

          if (isActionItemSaved) {
            actionItem.isSubmitted = true;
            actionItem.comments = '';
            actionItem.commentHistory = conversationHistory;
            // You could clear attached files here or keep for history if needed
            this.actionPlanService.setActionPlanCountChange(true);
            this.populateActionItemsData();
          }
        });
    }
  }

  private _buildConversationHistory(actionItem: any): string {
    const currentDate = new Date();
    const dateString = `${currentDate.getDate()}.${currentDate.getMonth() + 1}.${currentDate.getFullYear()}`;
    const userComment = `${this.userDetails?.firstname} ${this.userDetails?.lastname} - ${dateString} : ${actionItem.comments}`;

    if (actionItem?.commentHistory) {
      return actionItem.commentHistory + "\n" + userComment;
    }
    return userComment;
  }
  updateComment(actionItem: any, comment: any) {
    if (comment) {
      actionItem.comments = comment;
    }
  }

  attachFile(actionItem: any, files: any) {
    if (files && files?.length > 0) {
      const attachedFile: File = files[0];
      actionItem.fileName = files[0].name;
      actionItem.attachedFile = attachedFile;
    }
  }

  deleteFileOld(actionItem: any) {
    delete actionItem?.fileName;
    delete actionItem?.attachedFile;

    const rqstBody = {
      responseguid: actionItem.actionItemId
    }
    this.assessmentService.deleteFileFromServer(rqstBody).subscribe((data: any) => {
      let decryptedData = this.commonService.decryptUsingAES256(data?.data);
    });
  }

  callUploadFile(attachmentRqstBody: any) {

    return from(this.commonService.fileToBase64(attachmentRqstBody.documentBody)).pipe(
      switchMap((data: any) => {
        attachmentRqstBody.documentBody = data;
        return this.assessmentService.uploadFileToServer(attachmentRqstBody);
      })
    )
  }

  checkError(actionItem: any, value: string) {
    if (value && value.length > 0) {
      actionItem.showError = false;
    }
    else {
      actionItem.showError = true;
    }
  }

  generateAndDownload() {
    this.generatePdfCompRef?.generatePdf();
    //this.downloadActionItems();
  }

  downloadActionItems() {
    if (this.actionPlan?.actionPlanId) {
      const rqstBody = {
        responseguid: this.actionPlan?.actionPlanId,
        isDownload: true,
        type: "actionitem"
      }
      this.assessmentService.fetchUploadedFile(rqstBody).subscribe((res) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        if (resp?.filename && resp?.mimetype && resp?.documentbody) {
          this.downloadFile(resp?.documentbody, resp?.mimetype, resp?.filename)
        }
        else {
          this.openErrorPopup()
        }
      });
    }
  }

  downloadFile(linkSource: any, fileType: any, fileName: any) {
    const downloadLink = document.createElement('a');
    linkSource = 'data:' + fileType + ';base64,' + linkSource;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  downloadPdf(base64String: any, fileName: any) {
    const byteArray = new Uint8Array(atob(base64String).split('').map(char => char.charCodeAt(0)));
    const blobData = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blobData);
    // const source = `data:application/pdf;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.pdf`
    link.click();
  }

  openErrorPopup() {
    let message = '';
    if (this.isArabic) {
      message = 'لم يتم العثور على عناصر عمل قابلة للتنزيل';
    } else {
      message = 'No downloadable action items found';
    }

    const initialState = {
      message: message,
      redirectTo: '',
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { initialState });
  }

  openConfirmationComp(actionItem: any) {
    let message = '';
    let messageOne = '';
    if (this.isArabic) {
      message = '';
      messageOne = 'هل أنت متأكد أنك تريد المتابعة؟';
    } else {
      message = '';
      messageOne = 'Are you sure you want to proceed ?';
    }

    const initialState = {
      message: message,
      messageOne: messageOne,
      redirectTo: '',
      cancelButton: true
    };
    this.modalRefConfirm = this.modalService.show(SubmitConfirmationComponent, { initialState });

    this.notificationSubscription = this.categoryService.submitConfirmationStatus$.subscribe((value) => {
      if (value == 'ok') {
        this.submitActionItem(actionItem);
      } else {
        // this.disabledBtn = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }


  // When files are selected or replaced
  onFileSelected(event: Event, item: any) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    // Convert FileList to array and append or replace as needed
    // Here, we append new files:
    const filesArray = Array.from(input.files);

    // Example: Append files to item.attachedFiles (can adapt to replace if needed)
    item.attachedFiles = item.attachedFiles.concat(filesArray);

    // Clear the input so the same file can be re-selected if required
    input.value = '';
  }

  // Delete a file from the attachedFiles list for an item
  onDeleteFile(item: any, fileIndex: number) {
    if (item.attachedFiles && item.attachedFiles.length > fileIndex) {
      item.attachedFiles.splice(fileIndex, 1);
    }
  }
  attachFiles(actionItem: any, files: FileList | File[]) {
    if (!files || files.length === 0) return;

    const filesArr = Array.from(files);
    const MAX_NEW_FILES = 10;
    const MAX_NEW_FILES_TOTAL_SIZE = 20 * 1024 * 1024; // 20 MB

    if (!actionItem.attachedFiles) {
      actionItem.attachedFiles = [];
    }

    // Filter to count only new files (no isExisting flag)
    const existingFilesCount = actionItem.attachedFiles.filter((f: any) => f.isExisting === true).length;
    const currentNewFiles = actionItem.attachedFiles.filter((f: any) => !f.isExisting);

    // Check how many new files already attached
    const newFilesCount = currentNewFiles.length;

    // Total new files after adding new selection
    if (newFilesCount + filesArr.length > MAX_NEW_FILES) {
      return !this.isArabic ? alert(`You can only attach up to ${MAX_NEW_FILES} new files.`) : alert(`يمكنك إرفاق ما يصل إلى ${MAX_NEW_FILES} مستندات فقط.`);

    }

    // Calculate total size of existing new files + new selection
    const currentNewFilesSize = currentNewFiles.reduce((sum: number, f: File) => sum + f.size, 0);
    const newFilesSize = filesArr.reduce((sum: number, f: File) => sum + f.size, 0);
    const totalNewFilesSize = currentNewFilesSize + newFilesSize;

    if (totalNewFilesSize > MAX_NEW_FILES_TOTAL_SIZE) {
      return !this.isArabic ? alert('Total size of newly selected files exceeds the 20 MB limit. Please select fewer or smaller files.') : alert('يجب ألا يتجاوز الحجم الإجمالي لجميع الملفات المضافة حديثًا 20 ميجابايت.');
    }

    // Append new files (no isExisting flag)
    actionItem.attachedFiles.push(...filesArr);

    // Update fileName string for all attached files
    actionItem.fileName = actionItem.attachedFiles.map((f: any) => f.name).join(', ');

    // console.log(`New files count after adding: ${newFilesCount + filesArr.length}`);
    // console.log(`Total new files size (MB): ${(totalNewFilesSize / (1024 * 1024)).toFixed(2)}`);
  }

  // updateActionItem method — extracts actionItemId correctly depending on type
  updateActionItem(idStr: any, value: any, type: any) {
    // console.log('updateActionItem called with:', { idStr, value, type });

    if (!idStr) {
      console.warn('No idStr provided');
      return;
    }

    // Split ID by underscore
    const parts = idStr.split('_');

    // For different update types, extract id accordingly:
    let extractedId: string | undefined;

    if (type === this.UPDATE_TYPE.FILE_DELETE) {
      // For delete where id has format like 'notesdelete_actionItemId_fileIndex'
      if (parts.length >= 2) {
        extractedId = parts[parts.length - 2]; // second last part is actionItemId
      }
    } else {
      // For other types like comment, upload, submit
      extractedId = parts.pop(); // last part is actionItemId
    }

    if (!extractedId) {
      console.warn('Could not extract actionItemId from idStr:', idStr);
      return;
    }

    // Match item in list — ensure type match (string vs number)
    const actionItems = this.actionItemsList?.filter((item: any) =>
      String(item?.actionItemId) === String(extractedId)
    );

    // console.log('Extracted actionItemId:', extractedId);
    // console.log('Matching actionItems:', actionItems);

    if (actionItems && actionItems.length > 0 && actionItems[0]) {
      let actionItem = actionItems[0];

      switch (type) {
        case this.UPDATE_TYPE.COMMENT:
          // console.log('Updating comment:', value);
          this.updateComment(actionItem, value);
          break;

        case this.UPDATE_TYPE.FILE_UPSERT:
          // console.log('Attaching files:', value);
          this.attachFiles(actionItem, value);
          break;

        case this.UPDATE_TYPE.FILE_DELETE: {
          const fileIndex = Number(value);
          if (isNaN(fileIndex)) {
            console.warn('Invalid file index for delete:', value);
            return;
          }
          // console.log('Deleting file at index:', fileIndex);
          this.deleteFile(actionItem, fileIndex);
          break;
        }

        case this.UPDATE_TYPE.SUBMIT:
          // console.log('Submitting actionItem');
          this.submitActionItemCheck(actionItem);
          break;

        case this.UPDATE_TYPE.ENABLE_DISABLE_SUBMIT:
          // console.log('Checking error:', value);
          this.checkError(actionItem, value);
          break;

        default:
          console.warn('Unknown update type:', type);
          break;
      }
    } else {
      console.warn('No matching actionItem found for extractedId:', extractedId);
    }
  }


  // deleteFile accepts actionItem and fileIndex, deletes the file and calls backend
  deleteFile(actionItem: any, fileIndex: number) {
    if (!actionItem.attachedFiles || !actionItem.attachedFiles[fileIndex]) return;

    const fileToDelete = actionItem.attachedFiles[fileIndex];

    if (fileToDelete.isExisting) {
      // Call backend delete API by file identifier
      const rqstBody = {
        responseguid: actionItem.actionItemId,
        filename: fileToDelete.name,
        // or other id if available
      };

      this.assessmentService.deleteFileFromServer(rqstBody).subscribe({
        next: () => {
          // Remove from frontend only after successful backend delete
          actionItem.attachedFiles.splice(fileIndex, 1);
        },
        error: err => {
          console.error('Error deleting existing file:', err);
        }
      });
    } else {
      // Just remove locally - file not uploaded yet
      actionItem.attachedFiles.splice(fileIndex, 1);
    }

    // Update filename display string if used
    actionItem.fileName = actionItem.attachedFiles.length
      ? actionItem.attachedFiles.map((f: any) => f.name).join(', ')
      : null;
  }


  // Example of handleChangeDelegation adapted with file input value reset
  handleChangeDelegation(event: any) {
    if (event.target.nodeName === "TEXTAREA" || event.target.nodeName === "INPUT") {
      const attrList = Array.from(event.target.attributes)
        .map((x: any) => x.name)
        .filter((y: any) => y === "commentsbox" || y === "notesupload" || y === "notesedit");

      if (attrList.length > 0) {
        switch (attrList[0]) {
          case 'commentsbox':
            this.updateActionItem(event.target.id, event.target.value, this.UPDATE_TYPE.COMMENT);
            break;

          case 'notesupload':
          case 'notesedit':
            this.updateActionItem(event.target.id, event.target.files, this.UPDATE_TYPE.FILE_UPSERT);
            // Reset input so same file selection works repeatedly
            event.target.value = '';
            break;

          default: break;
        }
      }
    }
  }


  // Example handlePlanButtonsDelegation to support delete with fileIndex extracted from data attribute
  handlePlanButtonsDelegation(event: any) {
    if (event.target.nodeName === "BUTTON" || event.target.nodeName === "IMG") {
      const attrList = Array.from(event.target.attributes)
        .map((x: any) => x.name)
        .filter((y: any) => y === "notesdelete" || y === "actionitemsubmit");

      if (attrList.length > 0) {
        switch (attrList[0]) {
          case 'notesdelete': {
            const fileIndexStr = event.target.getAttribute('data-file-index');
            const fileIndex = fileIndexStr !== null ? Number(fileIndexStr) : NaN;

            if (!isNaN(fileIndex)) {
              this.updateActionItem(event.target.id, fileIndex, this.UPDATE_TYPE.FILE_DELETE);
            } else {
              console.warn('Invalid or missing file index for delete');
            }
            break;
          }
          case 'actionitemsubmit':
            this.updateActionItem(event.target.id, null, this.UPDATE_TYPE.SUBMIT);
            break;
          default:
            break;
        }
      }
    }
  }
  // deleteFile(actionItem: any, fileIndex: number) {
  //   // console.log("dele" ,actionItem)
  //   if (!actionItem.attachedFiles || actionItem.attachedFiles.length <= fileIndex) return;

  //   const fileToDelete = actionItem.attachedFiles[fileIndex];

  //   // Remove the file from the attachedFiles array
  //   actionItem.attachedFiles.splice(fileIndex, 1);

  //   // Optionally update fileName summary string
  //   actionItem.fileName = actionItem.attachedFiles.length
  //     ? actionItem.attachedFiles.map((f: File | any) => f.name).join(', ')
  //     : null;

  //   // Prepare payload for backend delete - you must uniquely identify the file, 
  //   // assuming `responseguid` and `filename` together:
  //   const rqstBody = {
  //     responseguid: actionItem.actionItemId,
  //     filename: fileToDelete.name  // or other property identifiable to backend
  //   };
  //   // console.log("deleting l..", rqstBody)
  //   // Call to backend service
  //   this.assessmentService.deleteFileFromServer(rqstBody).subscribe((data: any) => {
  //     let decryptedData = this.commonService.decryptUsingAES256(data?.data);
  //     // Handle response if required
  //     // console.log("deleted ", decryptedData)
  //   });
  // }

  // Show popup and reset progress
  showUploadPopup() {
    const overlay = document.querySelector('.upload-overlay') as HTMLElement;

    const popup = document.getElementById('uploadPopup');
    const progressBar = document.getElementById('uploadProgressBar') as HTMLProgressElement;
    const progressPercent = document.getElementById('progressPercent');

    if (popup && progressBar && progressPercent) {
      popup.style.display = 'block';
      progressBar.value = 0;
      progressPercent.textContent = '0%';
    }
    if (overlay) overlay.style.display = 'block';

  }

  // Update progress
  updateUploadProgress(percent: number) {
    // console.log('updateUploadProgress called with percent:', percent);  // <-- DEBUG 

    const progressBar = document.getElementById('uploadProgressBar') as HTMLProgressElement;
    const progressPercent = document.getElementById('progressPercent');


    if (progressBar && progressPercent) {
      progressBar.value = percent;
      progressPercent.textContent = `${percent}%`;
      this.cd.detectChanges();

    }
  }

  // Hide popup
  hideUploadPopup() {
    const popup = document.getElementById('uploadPopup');
    if (popup) {
      popup.style.display = 'none';
    }
    const overlay = document.querySelector('.upload-overlay') as HTMLElement;
    if (overlay) overlay.style.display = 'none';
  }
}
